import { render, staticRenderFns } from "./MatterRegionalCourtOfAppealForm.vue?vue&type=template&id=461c8b1a&"
import script from "./MatterRegionalCourtOfAppealForm.vue?vue&type=script&lang=js&"
export * from "./MatterRegionalCourtOfAppealForm.vue?vue&type=script&lang=js&"
import style0 from "./MatterRegionalCourtOfAppealForm.vue?vue&type=style&index=0&id=461c8b1a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports